export default "__VITE_ASSET__BakB4bIf__"